export default "__VITE_ASSET__CM6a5L7Z__"